const apiUrl = import.meta.env.VITE_API || 'http://localhost:3000';

export const env = {
  // API URLs
  API_URL: apiUrl,
  GRAPHQL_URL: import.meta.env.VITE_GRAPHQL_URL || `${apiUrl}/graphql`,

  // AWS
  AWS_REGION: import.meta.env.VITE_AWS_REGION || 'us-east-1',
  AWS_S3_BUCKET: import.meta.env.VITE_AWS_S3_BUCKET || 'simplelease-uploads-dev',

  // Analytics
  PENDO_KEY: import.meta.env.VITE_PENDO_KEY || '',
  GTM_ID: import.meta.env.VITE_GTM_ID || '',

  // Development
  NODE_ENV: import.meta.env.MODE || 'development',
  IS_DEVELOPMENT: import.meta.env.DEV,
  IS_PRODUCTION: import.meta.env.PROD,
};
